module.exports = "/assets/dist/images/iphone_w_car.png?44b1fb6a51de8b42b7a000d04fce4bbd";